<div class="mx-auto w-full lg:w-4/5">
  <div class="card card-compact mb-4 mt-2 rounded-lg bg-white">
    <div class="card-body">
      <yr-sales></yr-sales>
    </div>
  </div>

  <yr-credit-statements></yr-credit-statements>
</div>
